/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
  MessagingChannelCollection,
  MessagingChannelUnlinkResponse,
  MessagingLinkCode,
  SendblueMessageWebhook,
  WhatsAppConnectCompletionRequest,
  WhatsAppConnectEntry,
  WhatsAppEntry,
  WhatsAppLinkRequest,
  WhatsAppLinkResponse,
} from "../models/index";
import {
  MessagingChannelCollectionFromJSON,
  MessagingChannelCollectionToJSON,
  MessagingChannelUnlinkResponseFromJSON,
  MessagingChannelUnlinkResponseToJSON,
  MessagingLinkCodeFromJSON,
  MessagingLinkCodeToJSON,
  SendblueMessageWebhookFromJSON,
  SendblueMessageWebhookToJSON,
  WhatsAppConnectCompletionRequestFromJSON,
  WhatsAppConnectCompletionRequestToJSON,
  WhatsAppConnectEntryFromJSON,
  WhatsAppConnectEntryToJSON,
  WhatsAppEntryFromJSON,
  WhatsAppEntryToJSON,
  WhatsAppLinkRequestFromJSON,
  WhatsAppLinkRequestToJSON,
  WhatsAppLinkResponseFromJSON,
  WhatsAppLinkResponseToJSON,
} from "../models/index";

export interface MessagingChannelsChannelIdDeleteRequest {
  channelId: string;
}

export interface MessagingChannelsWhatsappCompletePostRequest {
  whatsAppConnectCompletionRequest: WhatsAppConnectCompletionRequest;
}

export interface MessagingChannelsWhatsappLinkPostRequest {
  whatsAppLinkRequest: WhatsAppLinkRequest;
}

export interface WebhooksSendblueReceivePostRequest {
  sendblueMessageWebhook: SendblueMessageWebhook;
}

export interface WebhooksSendblueStatusPostRequest {
  sendblueMessageWebhook: SendblueMessageWebhook;
}

/**
 *
 */
export class MessagingApi extends runtime.BaseAPI {
  /**
   * Unlink one of the caller\'s messaging channels.
   */
  async messagingChannelsChannelIdDeleteRaw(
    requestParameters: MessagingChannelsChannelIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<MessagingChannelUnlinkResponse>> {
    if (requestParameters["channelId"] == null) {
      throw new runtime.RequiredError(
        "channelId",
        'Required parameter "channelId" was null or undefined when calling messagingChannelsChannelIdDelete().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/messaging/channels/{channel_id}`;
    urlPath = urlPath.replace(
      `{${"channel_id"}}`,
      encodeURIComponent(String(requestParameters["channelId"]))
    );

    const response = await this.request(
      {
        path: urlPath,
        method: "DELETE",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MessagingChannelUnlinkResponseFromJSON(jsonValue)
    );
  }

  /**
   * Unlink one of the caller\'s messaging channels.
   */
  async messagingChannelsChannelIdDelete(
    requestParameters: MessagingChannelsChannelIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<MessagingChannelUnlinkResponse> {
    const response = await this.messagingChannelsChannelIdDeleteRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * List the caller\'s active linked messaging channels.
   */
  async messagingChannelsGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<MessagingChannelCollection>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/messaging/channels`;

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MessagingChannelCollectionFromJSON(jsonValue)
    );
  }

  /**
   * List the caller\'s active linked messaging channels.
   */
  async messagingChannelsGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<MessagingChannelCollection> {
    const response = await this.messagingChannelsGetRaw(initOverrides);
    return await response.value();
  }

  /**
   * Issue a short-lived code for linking the caller\'s Sendblue identity.
   */
  async messagingChannelsSendblueLinkCodePostRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<MessagingLinkCode>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/messaging/channels/sendblue/link-code`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      MessagingLinkCodeFromJSON(jsonValue)
    );
  }

  /**
   * Issue a short-lived code for linking the caller\'s Sendblue identity.
   */
  async messagingChannelsSendblueLinkCodePost(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<MessagingLinkCode> {
    const response =
      await this.messagingChannelsSendblueLinkCodePostRaw(initOverrides);
    return await response.value();
  }

  /**
   * Complete an account-bound invitation using the separate WhatsApp reply capability.
   */
  async messagingChannelsWhatsappCompletePostRaw(
    requestParameters: MessagingChannelsWhatsappCompletePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WhatsAppLinkResponse>> {
    if (requestParameters["whatsAppConnectCompletionRequest"] == null) {
      throw new runtime.RequiredError(
        "whatsAppConnectCompletionRequest",
        'Required parameter "whatsAppConnectCompletionRequest" was null or undefined when calling messagingChannelsWhatsappCompletePost().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/messaging/channels/whatsapp/complete`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: WhatsAppConnectCompletionRequestToJSON(
          requestParameters["whatsAppConnectCompletionRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WhatsAppLinkResponseFromJSON(jsonValue)
    );
  }

  /**
   * Complete an account-bound invitation using the separate WhatsApp reply capability.
   */
  async messagingChannelsWhatsappCompletePost(
    requestParameters: MessagingChannelsWhatsappCompletePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WhatsAppLinkResponse> {
    const response = await this.messagingChannelsWhatsappCompletePostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Issue an expiring WhatsApp invitation bound to the authenticated account.
   */
  async messagingChannelsWhatsappConnectPostRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WhatsAppConnectEntry>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/messaging/channels/whatsapp/connect`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WhatsAppConnectEntryFromJSON(jsonValue)
    );
  }

  /**
   * Issue an expiring WhatsApp invitation bound to the authenticated account.
   */
  async messagingChannelsWhatsappConnectPost(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WhatsAppConnectEntry> {
    const response =
      await this.messagingChannelsWhatsappConnectPostRaw(initOverrides);
    return await response.value();
  }

  /**
   * Get the WhatsApp destination and the caller\'s masked connection for the beta.
   */
  async messagingChannelsWhatsappEntryGetRaw(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WhatsAppEntry>> {
    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/messaging/channels/whatsapp/entry`;

    const response = await this.request(
      {
        path: urlPath,
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WhatsAppEntryFromJSON(jsonValue)
    );
  }

  /**
   * Get the WhatsApp destination and the caller\'s masked connection for the beta.
   */
  async messagingChannelsWhatsappEntryGet(
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WhatsAppEntry> {
    const response =
      await this.messagingChannelsWhatsappEntryGetRaw(initOverrides);
    return await response.value();
  }

  /**
   * Inspect or advance a sender-bound WhatsApp link using the authenticated account.
   */
  async messagingChannelsWhatsappLinkPostRaw(
    requestParameters: MessagingChannelsWhatsappLinkPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<WhatsAppLinkResponse>> {
    if (requestParameters["whatsAppLinkRequest"] == null) {
      throw new runtime.RequiredError(
        "whatsAppLinkRequest",
        'Required parameter "whatsAppLinkRequest" was null or undefined when calling messagingChannelsWhatsappLinkPost().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.accessToken) {
      // oauth required
      headerParameters["Authorization"] = await this.configuration.accessToken(
        "common_auth",
        []
      );
    }

    let urlPath = `/messaging/channels/whatsapp/link`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: WhatsAppLinkRequestToJSON(
          requestParameters["whatsAppLinkRequest"]
        ),
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      WhatsAppLinkResponseFromJSON(jsonValue)
    );
  }

  /**
   * Inspect or advance a sender-bound WhatsApp link using the authenticated account.
   */
  async messagingChannelsWhatsappLinkPost(
    requestParameters: MessagingChannelsWhatsappLinkPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<WhatsAppLinkResponse> {
    const response = await this.messagingChannelsWhatsappLinkPostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }

  /**
   * Persist and enqueue an authenticated Sendblue inbound-message callback.
   */
  async webhooksSendblueReceivePostRaw(
    requestParameters: WebhooksSendblueReceivePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["sendblueMessageWebhook"] == null) {
      throw new runtime.RequiredError(
        "sendblueMessageWebhook",
        'Required parameter "sendblueMessageWebhook" was null or undefined when calling webhooksSendblueReceivePost().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["sb-signing-secret"] =
        await this.configuration.apiKey("sb-signing-secret"); // sendblue_webhook_secret authentication
    }

    let urlPath = `/webhooks/sendblue/receive`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SendblueMessageWebhookToJSON(
          requestParameters["sendblueMessageWebhook"]
        ),
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Persist and enqueue an authenticated Sendblue inbound-message callback.
   */
  async webhooksSendblueReceivePost(
    requestParameters: WebhooksSendblueReceivePostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.webhooksSendblueReceivePostRaw(requestParameters, initOverrides);
  }

  /**
   * Persist and enqueue an authenticated Sendblue outbound-status callback.
   */
  async webhooksSendblueStatusPostRaw(
    requestParameters: WebhooksSendblueStatusPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters["sendblueMessageWebhook"] == null) {
      throw new runtime.RequiredError(
        "sendblueMessageWebhook",
        'Required parameter "sendblueMessageWebhook" was null or undefined when calling webhooksSendblueStatusPost().'
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters["Content-Type"] = "application/json";

    if (this.configuration && this.configuration.apiKey) {
      headerParameters["sb-signing-secret"] =
        await this.configuration.apiKey("sb-signing-secret"); // sendblue_webhook_secret authentication
    }

    let urlPath = `/webhooks/sendblue/status`;

    const response = await this.request(
      {
        path: urlPath,
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: SendblueMessageWebhookToJSON(
          requestParameters["sendblueMessageWebhook"]
        ),
      },
      initOverrides
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Persist and enqueue an authenticated Sendblue outbound-status callback.
   */
  async webhooksSendblueStatusPost(
    requestParameters: WebhooksSendblueStatusPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction
  ): Promise<void> {
    await this.webhooksSendblueStatusPostRaw(requestParameters, initOverrides);
  }
}
